export default __webpack_public_path__ + "static/media/rocket.1fd50109.jpg";